import { closeBtn } from 'icons/close';
import leftArrow from 'icons/left.svg';
import rightArrow from 'icons/right.svg';
import './carouselImgPreview.scss';

export const CarouselImgPreviewTemplate = (model) => {
	/* html */
	const html = `
		<div 
            class="engt-preview-close engt-tab-selectable" 
            id="engtPreviewClose"
            onkeydown="ENGT_CHAT.onEnterPress()"
			tabindex="2"
			>
				${closeBtn('#403f42')}
        </div>
		<div class="engt-popup-carousel" dir="auto">
			<button class="engt-popup-carousel-arrow engt-popup-carousel-left" tabindex="2">
				<img src="${leftArrow}" width="12" height="16" alt="preview-img-left" style="margin-right: 2px" loader="lazy"/>
			</button>
			<list-of-imgs></list-of-imgs>
			<button class="engt-popup-carousel-arrow engt-popup-carousel-right" tabindex="2">
				<img src="${rightArrow}" width="12" height="16" alt="preview-img-right" style="margin-left: 2px" loader="lazy"/>
			</button>
		</div>
        `;

	return html;
};
